/*
 * @Author: changcheng
 * @LastEditTime: 2023-12-14 16:10:18
 */
import liveHeaderBg from "@root/img/live_header_bg.png";
import liveDefault from "@root/img/live_default.png";
import livePlay from "@root/img/live_play_btn.png";
import contract from "@root/img/contace.png";
import liveMeeting from "@root/img/live_meeting.png";
import "./index.scss";
import { linkToCClive } from "@root/common/service";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
const liveRoomData = [
  {
    name: "直播线路一",
    roomId: "96DBA2E97147E3B09C33DC5901307461",
    ccUserId: "AA247F3728571B49",
  },
  {
    name: "直播线路二",
    roomId: "6D213268703213F09C33DC5901307461",
    ccUserId: "D71B0368E20B4CF5",
  },
];
export default function Live20231010am() {
  const navigate = useNavigate();
  return (
    <div>
      <div className="live_header">
        <img src={liveHeaderBg} alt="" width={"100%"} height={"252px"} />
        <div className="content">
          <p>“千县工程”四大类中心建设指南</p>
          <p>发&nbsp;布&nbsp;工&nbsp;作&nbsp;会</p>
          <p>2023年10月13日 09:00-12:30</p>
        </div>
      </div>
      <div className="live_main">
        <div className="live_default_entry">
          {liveRoomData.map((item) => (
            <div
              className="play_default_box"
              onClick={async () => {
                const { roomId, ccUserId } = item;
                const { data } = await linkToCClive(roomId, ccUserId);
                if (data === "未登录，请登录后再试") {
                  navigate("/home/index");
                  message.info(data);
                } else {
                  window.location.href = data;
                }
              }}
            >
              <img src={liveDefault} alt="" />
              <p>{item.name}</p>
              <img src={livePlay} alt="" className="play" />
            </div>
          ))}
        </div>
        <div className="live_content">
          <div className="content">
            <p className="title">
              <img src={contract} alt="" />
              <h3>联系人</h3>
            </p>
            <p>技术支持</p>
            <p>刘颜格 13810331953</p>
            <p>荆慧铭 13910899765</p>
          </div>
          <div className="content pad">
            <p className="title">
              <img src={liveMeeting} alt="" />
              <h3>会议日程</h3>
            </p>
            <p className="spot">
              2023年10月13日 09:00-12:30 线下地点：北京·新世纪日航酒店
            </p>
            <div className="timeline-list">
              <div className="timeline-item">
                <p className="time">09:30-09:50</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>领导致辞</span>
                    <span>待定 国家卫生健康委发展中心研究中心领导</span>
                    <span>主持：国家卫生健康委卫生发展研究中心</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">09:50-10:20</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>“千县工程”政策解读</span>
                    <span>待定 国家卫生健康委医政司医疗资源处相关负责人</span>
                    <span>主持：张牧嘉 国家卫生健康委医政司医疗资源处</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">09:50-10:20</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>“千县工程”四大类中心指南介绍和工作规划</span>
                    <span>黄二丹 国家卫生健康委卫生发展研究中心</span>
                    <span>主持：张牧嘉 国家卫生健康委医政司医疗资源处</span>
                  </div>
                </div>
              </div>
              <div className="timeline-item">
                <p className="time">10:50-12:30</p>
                <div className="timeline-item_tail"></div>
                <div className="timeline-item_node"></div>
                <div className="timeline-item_wrapper">
                  <div className="timeline-item_content">
                    <span>圆桌讨论</span>
                    <span>讨论话题 1: 全省一盘棋，统筹推进“千县工程”</span>
                    <span>参与嘉宾: 代表省份卫生健康委医政处负责人</span>
                    <span>主持：蒋乃珺 中国医药卫生文化协会培训部</span>
                  </div>
                  <div className="timeline-item_content">
                    <span>讨论话题 2: 中心化发展的专家赋能</span>
                    <span>参与嘉宾: 中心指南编写专家代表</span>
                    <span>主持：江蒙喜 国家卫生健康委卫生发展研究中心</span>
                  </div>
                  <div className="timeline-item_content">
                    <span>
                      讨论话题 3: 从指南到实践路径，县医院的高质量发展方案
                    </span>
                    <span>参与嘉宾:“千县工程”县医院代表</span>
                    <span>主持：汪言安 健康县域传播平台</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
